import { get, post, put, del } from "./ApiService";

const CHECKLIST_ENDPOINT = "/bug_checklist";

// Bir işin checklist maddelerini getirir (position'a göre sıralı gelir)
export const getChecklist = async (bugId) => {
  const response = await get(CHECKLIST_ENDPOINT, { bug_id: bugId });
  return Array.isArray(response?.checklist) ? response.checklist : [];
};

// Yeni checklist maddesi ekler
export const addChecklistItem = async ({ bugId, title } = {}) => {
  const response = await post(CHECKLIST_ENDPOINT, {
    bug_id: bugId,
    title,
  });

  if (response?.status === "error") {
    throw new Error(response?.message || "Madde eklenemedi.");
  }

  return response?.item || null;
};

// Madde günceller (title, is_done veya position)
export const updateChecklistItem = async ({ id, title, isDone, position } = {}) => {
  const payload = { id };
  if (title !== undefined) payload.title = title;
  if (isDone !== undefined) payload.is_done = isDone ? 1 : 0;
  if (position !== undefined) payload.position = position;

  const response = await put(CHECKLIST_ENDPOINT, payload);

  if (response?.status === "error") {
    throw new Error(response?.message || "Madde güncellenemedi.");
  }

  return response?.item || null;
};

// Madde siler
export const removeChecklistItem = async ({ id } = {}) => {
  const response = await del(CHECKLIST_ENDPOINT, { id });

  if (response?.status === "error") {
    throw new Error(response?.message || "Madde silinemedi.");
  }

  return response;
};
